import styled from "styled-components";
import { visuallyHiddenCss } from "@streeteasy/design-system/style-utilities/visually-hidden";

export const LocationSearchWrapper = styled.div`
  position: relative;
`;

export const SelectedLocationsWrapper = styled.div`
  margin-top: 16px;
`;

export const AriaLiveText = styled.div.attrs({
  "aria-live": "polite"
})`
  ${visuallyHiddenCss};
`;
